var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-special__promo-wrap"},[_c('transition',{attrs:{"name":"component-fade"}},[_c('div',{staticClass:"card-special__promo-item"},[_c('div',{staticClass:"promo-item__left"},[_c('div',{staticClass:"promo-item__img"},[_c('router-link',{attrs:{"to":_vm.$localize({
                                name: 'card',
                                params: {
                                    item: _vm.item.slug,
                                    id: _vm.item.id,
                                },
                            })}},[_c('img',{attrs:{"src":_vm.item.image,"alt":_vm.item.title,"title":_vm.item.title}})])],1)]),_c('div',{staticClass:"promo-item__right"},[_c('router-link',{staticClass:"promo-item__name",attrs:{"to":_vm.$localize({
                            name: 'card',
                            params: {
                                item: _vm.item.slug,
                                id: _vm.item.id,
                            },
                        })}},[_vm._v(" "+_vm._s(_vm.item.title)+" ")]),_c('div',{staticClass:"promo-item__price"},[(_vm.item.discount_price)?_c('div',{staticClass:"promo-item__price-current"},[_vm._v(" "+_vm._s(_vm.item.discount_price)+" ")]):_vm._e(),(_vm.item.price)?_c('div',{staticClass:"promo-item__price-sale",class:{
                            discount: _vm.item.discount_price,
                            'promo-item__price-current': !_vm.item.discount_price,
                        }},[_vm._v(" "+_vm._s(_vm.item.price)+" ")]):_vm._e()]),_c('div',{staticClass:"promo-item__rating"},[_c('star-rating',{attrs:{"max-rating":5,"increment":0.1,"rating":_vm.item.rating,"star-points":[
                            50.0,
                            0.0,
                            55.226,
                            0.274,
                            60.396,
                            1.093,
                            65.451,
                            2.447,
                            70.337,
                            4.323,
                            75.0,
                            6.699,
                            79.389,
                            9.549,
                            83.457,
                            12.843,
                            87.157,
                            16.544,
                            90.451,
                            20.611,
                            93.301,
                            25.0,
                            95.677,
                            29.663,
                            97.553,
                            34.549,
                            98.907,
                            39.604,
                            99.726,
                            44.774,
                            100.0,
                            50.0,
                            99.726,
                            55.226,
                            98.907,
                            60.396,
                            97.553,
                            65.451,
                            95.677,
                            70.337,
                            93.301,
                            75.0,
                            90.451,
                            79.389,
                            87.157,
                            83.457,
                            83.457,
                            87.157,
                            79.389,
                            90.451,
                            75.0,
                            93.301,
                            70.337,
                            95.677,
                            65.451,
                            97.553,
                            60.396,
                            98.907,
                            55.226,
                            99.726,
                            50.0,
                            100.0,
                            44.774,
                            99.726,
                            39.604,
                            98.907,
                            34.549,
                            97.553,
                            29.663,
                            95.677,
                            25.0,
                            93.301,
                            20.611,
                            90.451,
                            16.544,
                            87.157,
                            12.843,
                            83.457,
                            9.549,
                            79.389,
                            6.699,
                            75.0,
                            4.323,
                            70.337,
                            2.447,
                            65.451,
                            1.093,
                            60.396,
                            0.274,
                            55.226,
                            0.0,
                            50.0,
                            0.274,
                            44.774,
                            1.093,
                            39.604,
                            2.447,
                            34.549,
                            4.323,
                            29.663,
                            6.699,
                            25.0,
                            9.549,
                            20.611,
                            12.843,
                            16.544,
                            16.544,
                            12.843,
                            20.611,
                            9.549,
                            25.0,
                            6.699,
                            29.663,
                            4.323,
                            34.549,
                            2.447,
                            39.604,
                            1.093,
                            44.774,
                            0.274,
                            50.0,
                            0.0 ],"inactive-color":"#C4C4C4","active-color":"#FFD40C","read-only":true,"show-rating":false}})],1)],1)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }